


export const Footer = () => {
  const year = new Date().getFullYear()
  return (
    <footer  className="h-[830px] flex items-center justify-center  footer-gradient absolute bottom-0 w-screen">
      <a href="mailto:hello@avela.studio" className="font-magic  sm:text-[96px] text-h1-mobile hover:opacity-80 transition-all duration-300">hello@avela.studio</a>
      <p id="contact" className="absolute bottom-6 left-1/2 transform -translate-x-1/2 text-blue-main">{`©avelastudio ${year}`}</p>
    </footer>
  )
}